import { Resource as a, API as e } from "@coveo/platform-client";
const t = class t extends a {
  startJob(s) {
    return this.api.post(`${t.baseUrl}`, s);
  }
  getJobStatus(s) {
    return this.api.get(`${t.baseUrl}/${s}/status`);
  }
  getChunks(s) {
    return this.api.get(`${t.baseUrl}/${s}/result`);
  }
};
t.baseUrl = `/rest/organizations/${e.orgPlaceholder}/chunkinspector/document/v1/chunkretrievaljobs`;
let r = t;
export {
  r as ChunkInspectorDocumentResource
};
//# sourceMappingURL=ChunkInspectorDocument.js.map
